import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import TableCrudEnhanced from '../../components/TableCrudEnhanced';

const GroupIndex = () => {
    const navigate = useNavigate();

    const filterConfig = useMemo(() => [
        {
            type: "text",
            name: "name",
            label: "Name",
            placeholder: "Search by name..."
        }
    ], []);

    const columns = useMemo(() => [
        { 
            title: 'Name', 
            dataIndex: 'name', 
            key: 'name', 
            sortable: true 
        },
        { 
            title: 'Active', 
            dataIndex: 'isActive', 
            key: 'isActive', 
            width: 100,
            render: (value, record, index, handleToggleActive) => (
                <span 
                    className={`badge ${value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleActive && handleToggleActive(record)}
                    title={`Click to ${value ? 'deactivate' : 'activate'}`}
                >
                    {value ? 'Active' : 'Inactive'}
                </span>
            )
        },
        { 
            title: 'Deleted', 
            dataIndex: 'isDeleted', 
            key: 'isDeleted', 
            width: 100,
            render: (value, record, index, handleToggleActive, handleToggleDeleted) => (
                <span 
                    className={`badge ${!value ? 'bg-success' : 'bg-secondary'}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleDeleted && handleToggleDeleted(record)}
                    title={`Click to ${!value ? 'delete' : 'restore'}`}
                >
                    {!value ? 'Not Deleted' : 'Deleted'}
                </span>
            )
        }
    ], []);

    const actions = useMemo(() => [
        {
            label: 'Edit',
            onClick: (record) => navigate(`/group/edit/${record.groupID}`),
            type: 'primary'
        }
    ], [navigate]);

    return (
        <TableCrudEnhanced
            title="Group"
            apiEndpoint="/Group/getAllPaginated"
            toggleActiveEndpoint="/Group/toggleActive"
            toggleDeletedEndpoint="/Group/toggleDeleted"
            newRoute="/group/new"
            columns={columns}
            filterConfig={filterConfig}
            actions={actions}
            rowKey="groupID"
            initialPageSize={10}
            enableFilters={true}
            showAddButton={true}
        />
    );
};

export default GroupIndex;
